import { PaymentPaneStatus } from '@billy/design-system'

import { InvoiceStatus } from '@features/invoicesLegacy/enums/invoiceStatus'

export const invoiceStatusToPaymentPaneStatus: Record<InvoiceStatus, PaymentPaneStatus | undefined> = {
  [InvoiceStatus.All]: undefined,
  [InvoiceStatus.Credited]: PaymentPaneStatus.Success,
  [InvoiceStatus.Draft]: PaymentPaneStatus.Success,
  [InvoiceStatus.Overdue]: PaymentPaneStatus.Error,
  [InvoiceStatus.Paid]: PaymentPaneStatus.Success,
  [InvoiceStatus.PartiallyCredited]: undefined,
  [InvoiceStatus.PartiallyPaid]: undefined,
  [InvoiceStatus.Unpaid]: undefined,
}
